import React from 'react'
import { componentKey, setRowsPerPage, setSkip, setSelectedPayer, setStatusFilter, setPayerFilterText, setTaxYear, setSelectedTaxYear, setSelectedForm } from './StateFilingHistorySlice'
import Heading from '../../../components/heading/Heading'
import { HEADING } from '../../../components/heading/constants/constants'
import Label from '../../../components/label/Label'
import Checkbox from '../../../components/checkbox/basecheckbox/Checkbox'
import { useDispatch, useSelector } from 'react-redux'
import SelectDropdown from '../../../components/dropdown/selectdropdown/SelectDropdown'
import { useEffect } from 'react'
import { getFilingHistory, getFormsList, getPayerList, getStateFilingHistory, getTaxYearsList } from './StateFilingHistorySaga'
import styles from './StateFilingHistory.styles'
import { LABEL_WEIGHT } from '../../../components/label/constants'
import RichGrid from '../../../components/richgrid/RichGrid'
import { ROW_SELECTION_OPTIONS } from '../../../components/richgrid/constants'
import Loadable from '../../../components/loadable/Loadable'
import useGarbageCollector from "../../../../libs/garbagecollector/garbageCollectorHooks"
import { COMMON_LOADING_STATES, COMMON_LOADING_STATES_MESSAGE_MAP } from '../../constants/constants'
import useFormatTIN from '../../../../libs/customhooks/useFormatTIN'

export default function StateFilingHistory() {
	useGarbageCollector(componentKey)
	const { history, totalHistory, payersList, selectedPayer, loadingState, rowsPerPage, skip, taxYearsList, selectedTaxYear, formList, selectedForm } = useSelector((state) => state[componentKey])
	const dispatch = useDispatch();
    const { formatTIN } = useFormatTIN() 


	useEffect(() => {
		dispatch(getPayerList())
		dispatch(getTaxYearsList())
		dispatch(getFormsList())
	}, [])

	useEffect(() => {
		dispatch(getStateFilingHistory({ PageSize: rowsPerPage, PageNumber: (skip / rowsPerPage) + 1, taxYear: selectedTaxYear.value, formId: selectedForm.label, payer: selectedPayer.value }))
	}, [rowsPerPage, skip, selectedTaxYear, selectedForm, selectedPayer])

	const handleFilterChange = (name, selectedOption) => {
		switch (name) {
			case 'taxYear':
				dispatch(setSelectedTaxYear({ ...selectedOption }))
				break;
			case 'payer':
				dispatch(setSelectedPayer({ ...selectedOption }))
				break;
			case 'form':
				dispatch(setSelectedForm({ ...selectedOption }))
				break;
		}
	}

	const STATE_FILING_HISTORY_COLUMNS = [
		{
			field: "refID",
			header: <Label weight={LABEL_WEIGHT[700]} customStyles={{ ...styles.text }}>State File Ref ID</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.StateFileRefId}</span>
		},
		{
			field: "taxId",
			header: <Label weight={LABEL_WEIGHT[700]}>Tax ID</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{formatTIN(row.PIdType, row.TaxId, false)}</span>
		},
		{
			field: "recipient",
			header: <Label weight={LABEL_WEIGHT[700]}>Recipient</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.Recipient}</span>
		},
		{
			field: "formName",
			header: <Label weight={LABEL_WEIGHT[700]}>Form Name</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.FormName}</span>
		},
		{
			field: "stateReport",
			header: <Label weight={LABEL_WEIGHT[700]}>States Reported</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.StateName}</span>
		},
		{
			field: "status",
			header: <Label weight={LABEL_WEIGHT[700]}>Status</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.Status}</span>
		},
		{
			field: "eFileDate",
			header: <Label weight={LABEL_WEIGHT[700]}>eFile Date</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.EfileDate}</span>
		},
	]

	return (
		<>
			<Heading type={HEADING.H1}>State Filing History</Heading>
			<Loadable currentState={loadingState.state} loadingStates={COMMON_LOADING_STATES.FILTER_LOADING} messageMap={COMMON_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true}>
				<div style={styles.filterRow}>
					<div>
						<Label>Tax Year</Label>
						<SelectDropdown
							name="taxYear"
							value={{ label: selectedTaxYear.label, value: selectedTaxYear.value }}
							prefixProps={{ text: "" }}
							onSelectCb={(name, selectedOption) => handleFilterChange(name, selectedOption)}
							options={taxYearsList}
						/>
					</div>
					<div>
						<Label>Payer</Label>
						<SelectDropdown
							name="payer"
							value={{ label: selectedPayer.label, value: selectedPayer.value }}
							prefixProps={{ text: "" }}
							onSelectCb={(name, selectedOption) => handleFilterChange(name, selectedOption)}
							options={payersList}
						/>
					</div>
					<div>
						<Label>Form</Label>
						<SelectDropdown
							name="form"
							value={{ label: selectedForm.label, value: selectedForm.value }}
							prefixProps={{ text: "" }}
							onSelectCb={(name, selectedOption) => handleFilterChange(name, selectedOption)}
							options={formList}
						/>
					</div>
				</div>
			</Loadable>
			<Loadable currentState={loadingState.state} loadingStates={COMMON_LOADING_STATES.GRID_LOADING} messageMap={COMMON_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true}>
				<div style={styles.grid}>
					<RichGrid
						data={history}
						columns={STATE_FILING_HISTORY_COLUMNS}
						selectable={false}
						extractRowKey={(row) => row.RefNumber}
						paginationProps={{
							skip: skip,
							take: rowsPerPage,
							takeOptions: ROW_SELECTION_OPTIONS,
							onChangeTakeCb: (newTake) => {
								dispatch(setRowsPerPage(newTake));
								dispatch(setSkip(0))
							},
							total: totalHistory,
							onChange: (take, t) => {
								dispatch(setRowsPerPage(take));
								dispatch(setSkip(t))
							},
						}}
					/>
				</div>
			</Loadable>
		</>
	)
}